import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { trajanjeTeksta } from './stajanja';
import { googleLinkTacke, otvoriGoogle } from './googleLinkovi';

/* „Podaci o odabranom stajanju" — kartica nad oznakom stajanja.

   Redosled polja prati pitanja kojim redom se postavljaju: koje vozilo, ko je
   vozio, kad, koliko, na kojoj kilometraži, gde. Kilometraža je tu jer se po
   njoj stajanje uparuje sa tahografom i putnim nalogom.

   ── ADRESA STIŽE NAKNADNO ─────────────────────────────────────────────────
   Obrnuto geokodiranje ide jedan upit u sekundu, pa se za sva stajanja unapred
   ne traži — dvadeset stajanja bi značilo dvadeset sekundi čekanja na rutu.
   Traži se tek kad se OVA kartica otvori, i dok stiže stoji „Učitavanje…".
   Odgovor se kešira u bazi, pa se isto mesto plaća jednom. */

const Red = ({ naziv, vrednost, deca }) => {
    if (!deca && (vrednost === null || vrednost === undefined || vrednost === '')) return null;
    return (
        <div className="gps-staj-red">
            <span className="gps-staj-naziv">{naziv}</span>
            <span className="gps-staj-vrednost">{deca || vrednost}</span>
        </div>
    );
};

const PopupStajanje = ({ stajanje, vozilo, sektor, zovi }) => {
    const { t, i18n } = useTranslation();
    const [adresa, setAdresa] = useState(null);
    const [ucitava, setUcitava] = useState(false);
    const [kopirano, setKopirano] = useState(false);

    /* Traži se pri svakom otvaranju druge oznake — `stajanje` je nov objekat po
       stajanju, pa je i on ceo ključ efekta. */
    useEffect(() => {
        let ziv = true;
        setAdresa(null);
        setUcitava(true);
        /* Jezik ide uz zahtev — Nominatim inace vrati LOKALNI naziv drzave
           („Deutschland", „Italia"), pa se u istom spisku pomesa cetiri jezika. */
        zovi('/gps/reverzno', { lat: stajanje.lat, lng: stajanje.lng, jezik: i18n.language })
            .then(d => { if (ziv) setAdresa(d?.adresa || null); })
            .catch(() => { if (ziv) setAdresa(null); })
            .finally(() => { if (ziv) setUcitava(false); });
        return () => { ziv = false; };
    }, [stajanje, zovi, i18n.language]);

    const koordinate = `${Number(stajanje.lat).toFixed(4)},${Number(stajanje.lng).toFixed(4)}`;

    const kopiraj = async () => {
        try {
            await navigator.clipboard.writeText(koordinate);
            setKopirano(true);
            setTimeout(() => setKopirano(false), 1600);
        } catch (e) {
            /* Bez HTTPS-a clipboard ne postoji — koordinate su i dalje vidljive
               i mogu da se označe mišem, pa neuspeh ne treba prijavljivati. */
        }
    };

    const naziv = [vozilo?.registracija, [vozilo?.marka, vozilo?.model].filter(Boolean).join(' ').trim()]
        .filter(Boolean);

    return (
        <div className="gps-staj">
            <div className="gps-staj-naslov">{t('gps.stajanjeNaslov')}</div>

            <Red naziv={t('gps.vozilo')}
                 vrednost={naziv.length > 1 ? `${naziv[0]} (${naziv[1]})` : naziv[0]} />

            {/* Vozač se čita iz putnog naloga koji je trajao u tom trenutku —
                telemetrija ne pamti ko je sedeo za volanom. Kod dvočlane posade
                to je vodeći vozač naloga. */}
            <Red naziv={t('gps.stajanjeVozac')}
                 vrednost={stajanje.vozac
                     ? (sektor ? `${stajanje.vozac} (${sektor})` : stajanje.vozac)
                     : t('gps.stajanjeBezVozaca')} />

            <Red naziv={t('gps.stajanjeOdDo')} vrednost={`${stajanje.od} - ${stajanje.do}`} />

            <Red naziv={t('gps.stajanjeTrajanje')} deca={
                <span className={stajanje.duga ? 'gps-staj-duga' : undefined}>
                    {trajanjeTeksta(stajanje.sekundi)}
                    {!!stajanje.duga && <i className="pi pi-pause-circle" title={t('gps.stajanjeDugaOpis')} />}
                </span>
            } />

            <Red naziv={t('gps.stajanjeBrojcanik')}
                 vrednost={stajanje.km != null
                     ? `${Number(stajanje.km).toLocaleString('sr-RS')} km`
                     : null} />

            <Red naziv={t('gps.stajanjeLokacija')} deca={
                <span className="gps-staj-lokacija">
                    {ucitava
                        ? <em className="gps-staj-ceka">{t('gps.ucitavanje')}</em>
                        : (adresa || <em className="gps-staj-ceka">{t('gps.stajanjeBezAdrese')}</em>)}
                    <button
                        type="button"
                        className="gps-staj-dugme"
                        title={t('gps.pinOtvoriUGoogle')}
                        aria-label={t('gps.pinOtvoriUGoogle')}
                        onClick={() => otvoriGoogle(googleLinkTacke(stajanje))}
                    >
                        <i className="pi pi-external-link" />
                    </button>
                </span>
            } />

            <Red naziv={t('gps.stajanjeKoordinate')} deca={
                <span className="gps-staj-koord">
                    {koordinate}
                    <button
                        type="button"
                        className="gps-staj-dugme"
                        onClick={kopiraj}
                        title={kopirano ? t('gps.pinKopirano') : t('gps.pinKopirajKoordinate')}
                        aria-label={t('gps.pinKopirajKoordinate')}
                    >
                        <i className={kopirano ? 'pi pi-check' : 'pi pi-copy'} />
                    </button>
                </span>
            } />
        </div>
    );
};

export default PopupStajanje;
